export const useViewportStore = defineStore('viewportStore', {
	state: () => ({
		isMobile: false
	}),
	getters: {
		getIsMobileState: (state) => {
			return state.isMobile;
		}
	},
	actions: {
		setIsMobileState(value) {
            this.isMobile = value;
		},
	},
})
